document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-accordions]').forEach(function (container) {
    const accordions = container.querySelectorAll('.product-faq-accordion details');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      accordions.forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (this.open) {
            accordions.forEach(function (item) {
              if (item !== details) item.removeAttribute('open');
            });
          }
        });
      });
      return;
    }

    function openAccordion(details, content) {
      if (details.dataset.animating) return;
      details.dataset.animating = 'opening';
      details.setAttribute('open', '');
      content.style.overflow = 'hidden';
      content.style.height = '0px';
      content.style.opacity = '0';
      requestAnimationFrame(function () {
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = '1';
      });
      const onEnd = function (e) {
        if (e.propertyName !== 'height') return;
        content.style.height = 'auto';
        content.style.overflow = '';
        delete details.dataset.animating;
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd);
    }

    function closeAccordion(details, content) {
      if (details.dataset.animating) return;
      details.dataset.animating = 'closing';
      content.style.overflow = 'hidden';
      content.style.height = content.scrollHeight + 'px';
      content.style.opacity = '1';
      requestAnimationFrame(function () {
        content.style.height = '0px';
        content.style.opacity = '0';
      });
      const onEnd = function (e) {
        if (e.propertyName !== 'height') return;
        details.removeAttribute('open');
        content.style.height = '';
        content.style.overflow = '';
        content.style.opacity = '';
        delete details.dataset.animating;
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd);
    }

    accordions.forEach(function (details) {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = details.hasAttribute('open');

        if (isOpen) {
          closeAccordion(details, content);
        } else {
          accordions.forEach(function (item) {
            if (item !== details && item.hasAttribute('open')) {
              const otherContent = item.querySelector('.accordion__content');
              if (otherContent) closeAccordion(item, otherContent);
            }
          });
          openAccordion(details, content);
        }
      });
    });
  });
});
 